import { ButtonInterface } from 'atomic/utilization/button/button.interface';
import classNames from 'classnames';

import './button.scss';

export default function getButtonClasses(
    props: Pick<ButtonInterface, 'color' | 'block' | 'uppercase' | 'outline' | 'size'| 'weight' | 'noWrap' | 'disabled'>
): string {
    const btnClass = classNames({
        [props.outline ? `btn--${props.color}-outline` : `btn--${props.color}`]: true,
        [`btn--${props.size}`]: true,
        [`btn--fw-${props.weight}`]: true,
        'btn': true,
        'btn--': props.outline,
        'btn--block': props.block,
        'btn--nowrap': props.noWrap,
        'btn--uppercase': props.uppercase,
        'btn--disabled': props.disabled
    });

    return btnClass;
}
